import { useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense } from 'api';

type HookProps = {
  buyerMaterialSpecificationId: number;
};

export const useGetBuyerMaterialSpecificationDetails = ({ buyerMaterialSpecificationId }: HookProps) => {
  return useApiTradeV1BuyerMaterialSpecificationsRetrieveSuspense(buyerMaterialSpecificationId);
};
